import * as React from 'react';

import { TranslateFunction } from '@own-local/ad-utils/lib/types';

import { Tab } from './AdUnit';
import {
  EmailOutlineIcon,
  InformationOutlineIcon,
  CommentQuoteOutlineIcon,
  PostOutlineIcon,
  AudioPlayerIcon,
} from './Icons';

export interface TabNavProps {
  isAudio: boolean;
  tab: Tab;
  onClick: (tab: Tab) => () => void;
  activeTab: Tab;
  locale: string;
  translateString: TranslateFunction;
}

const TabNav = (props: TabNavProps) => {
  const { isAudio, locale, translateString } = props;

  let c = 'tab';
  let title = '';
  let role = 'button'
  let Icon: (props: any) => JSX.Element;

  if (props.tab === props.activeTab) {
    c += ' active';
  }

  switch (props.tab) {
    case Tab.Info:
      c += ' info-tab';
      title = translateString('contact_info', locale, 'Contact Info');
      Icon = InformationOutlineIcon;
      break;
    case Tab.About:
      c += ' about-tab';
      title = translateString('more_info', locale, 'More Info');
      Icon = isAudio ? AudioPlayerIcon : PostOutlineIcon;
      break;
    case Tab.Contact:
      c += ' contact-tab';
      title = translateString('sent_message', locale, 'Sent Message');
      Icon = EmailOutlineIcon;
      break;
    case Tab.Facebook:
      c += ' tab feed-tab';
      title = translateString('facebook_feed', locale, 'Facebook Feed');
      Icon = CommentQuoteOutlineIcon;
      break;
  }

  return (
    <button className={c} title={title} onClick={props.onClick(props.tab)} role={role}>
      <Icon fill="rgba(0,0,0,0.5)" />
    </button>
  );
};

export default TabNav;
